import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { PricingState } from "../pricingSlice";
import { createQuote } from "../thunks/createQuoteThunk";

export const addCreateQuoteReducers = (builder: ActionReducerMapBuilder<PricingState>) => {
  builder
    .addCase(createQuote.pending, (state) => {
      state.loading.quoteCreationLoading = true;
    })
    .addCase(createQuote.fulfilled, (state) => {
      state.loading.quoteCreationLoading = false;
    })
    .addCase(createQuote.rejected, (state) => {
      state.loading.quoteCreationLoading = false;
    });
};
